module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062652874_Contents#r_idParaDest-9"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("D09")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One-point-three seconds—and gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He touched his metal mouth even though he could not feel—neither physical touch nor emotional. Ana had never kissed him on the mouth before. On the cheek, yes, when she’d drunk too much of Wick’s Cercian ale. But never on the mouth. Her words echoed through his processors like a virus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("I’ll always come back for you. I promise you on iron and stars.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was more than a promise—it was an oath. Unbreakable. Strong like iron and steady like stars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was said that such promises could never be broken; the Goddess would not allow it. The probability of a supernatural binding was less than one percent, but the vow stuck with him all the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because Ana had never promised on iron and stars before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Ironbloods did not notice as she passed into the party. They laughed among themselves, leaning against statues of the Goddess, her marble gown flowing freely in a stone-petrified "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("breeze. The Goddess always looked up. He recalled how Ana hated that. But if she looked down, she would have seen men and women sipping on rose-scented champagne, oblivious of the poor living below this floating garden.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Ironbloods were too self-absorbed to notice Ana as she waded between them, deeper into the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He watched her for 7.3 seconds longer—until a signal pinged his processors. It was faint, easily hidden under the garden’s security radio chatter. Could it be the HIVE? He had never picked up the HIVE’s frequency before. Only Messiers could.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The signal began to grow louder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Easing down the stairwell again, he pressed himself against the wall and sank into a shadowy corner between the kitchen and the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An older man, graying beard braided down his chest, appeared at the far end of the hallway. Dark eyes and deep wrinkles and ghostly-pale skin. The clank of decorative medals on his breast accompanied his footsteps. He was dressed in a simple royal-purple evening coat with uneven tails, gilded buttons and filigree across the collar and sleeves. He carried with him a thin piece of glass with scrolling data—a holo-pad—that illuminated the hallway as he walked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Di recognized the man from countless newsfeeds and history books.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lord Rasovant. The creator of Metals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D09 had never seen him in person before, at least never a time his damaged memory core could recall, and it could not "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("recall anything from before the "), _c('i', [_vm._v("Dossier")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The strange signal was so close now, bouncing off the steel walls like ricocheting bullets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then "), _c('i', [_vm._v("find ")]), _vm._v("those coordinates,” the older man stressed in a sharp tone. “Surely one of the Messiers managed to get their faces.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As luck would have it, they did not,” replied the girl who trailed behind him. She walked with the grace of a dancer, floating without a sound. The pins in her flaxen hair matched her black dress. Floor-length, high collar, the insignia of the crown on her sleeve. She was a royal servant, and yet she spoke so informally to him that Di thought it strange."), _c('i'), _vm._v("“Rasovant, this ship is not worth our time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Iron Adviser stopped in the middle of the hallway and turned back to her. “Mercer stole that ship, and I want it back. Find it. Do whatever is necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever necessary?” The signal turned sharp and grating. It made D09 shudder, rattling his code. “Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Mellifare,” Lord Rasovant replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was not part of the plan. If Rasovant was looking for his own fleetship, then Di would let him find it—without interferrence. This was not worth the trouble it entailed, and he had promised Siege to keep Ana safe. This was not, in any definition of the word, "), _c('i', [_vm._v("safe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finding a way to fix his memory core was not worth Ana’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The servant girl, Mellifare, smiled. “My pleasure—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the far end of the hallway came a guard, clad in the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("royal purples of the crown. A Royal Guard. If the Royal Guard were here, then so was the Grand Duchess. The odds of him or Ana escaping decreased by the moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My lord, a moment,” said the guard. She was tall, with white-blond hair and arrowhead-shaped markings under her eyes—heritage markings for certain Cercian clans. The woman must have been from one of the few Cercian Ironblood families, as only Ironbloods could join the Royal Guard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Royal Captain Viera,” the Adviser greeted her. “What can I do for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There may have been a breach in security,” Viera replied, a hand resting on the lightsword at her hip. She was young to be the Royal Captain. Eighteen. If not for the Plague that had decimated an entire generation twenty years ago, he doubted she would be in such a position.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A breach?” asked the Iron Adviser.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, a waiter was found tied up in the pantry without clothes. We believe we have an imposter in the garden, and the Grand Duchess is not safe. Should I notify her or—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That will not be necessary. I will tell the Messiers to assist you so you can deal with this quietly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t need their assistance, my lord—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course you do, Captain. Messiers are here to protect, after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir,” replied the Royal Captain, trying to disguise the downturn of her mouth as she gave another low bow and left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the guards found Ana in the garden, she could not fend them off alone—and there was a 93.7 percent chance that she "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_c('i', [_vm._v("would ")]), _vm._v("fight. She did not know how not to.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The signal spiked again, tugging at his code. D09 jerked—and his metal elbow hit the wall with a resounding "), _c('i', [_vm._v("ding.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rasovant’s assistant snapped her gaze over. Her eyes narrowed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D09 went rigid as he raised firewalls against the signal. Another glitch picked at his code, pulling like kite strings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is something the matter?” asked Lord Rasovant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young woman shook her head. “Nothing important. Let us go—the Grand Duchess should be announcing her heir soon. . . .” She grabbed her elder by the hand and tugged him along the hallway. She did not look back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The spiking signal faded, until only an echo remained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sank to his knees, twitching as his programming righted itself again. If that assistant saw him, why did she not say so? The glitch tugging at his processors ebbed, giving him access to his own functions again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jax?”"), _c('i'), _vm._v("He sent out a comm-link to the skysailer. There was no answer for a moment, and then—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Messier. Stupid—gotta—trying hard—marina!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That did not bode well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rerouting his energy to his legs, he got to his feet. He would not glitch. Not now. Not yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He must find Ana.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7c2090","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062652874_Chapter_6.vue
// module id = 87
// module chunks = 0